import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import LocalizedStrings from 'react-localization';
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
import { ClientLanguage, getClientLanguageAsString } from "../../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        salaryRequest: "Jährliche Gehaltsvorstellung (Brutto)*",
        salaryRequestPlaceholder: "Jährliche Gehaltsvorstellung eingeben (Maximal 10 Zeichen angeben) ",
        salaryRequestRequired: "Angabe ist erforderlich",
        salaryRequestMaxCharacters:"Maximal 10 Zeichen möglich",

        entranceDate: "Frühestmöglicher Eintritt*",
        entranceDateRequired: "Angabe ist erforderlich",
        entranceDateValidationError: "Bitte geben Sie einen gültigen Wert an",
    },
    en:
    {
        salaryRequest: "Annual salary expectations (gross)*",
        salaryRequestPlaceholder: "Enter salary expectations (Enter maximum 10 characters) ",
        salaryRequestRequired: "Information required",
        salaryRequestMaxCharacters:"maximum 10 characters",

        entranceDate: "Earliest entry date*",
        entranceDateRequired: "Information required",
        entranceDateValidationError: "Please enter a valid value",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const Schema = (settings, clientLanguage) => Yup.object().shape({
    salaryRequest: Yup.string()
        .required(() => {
                setLanguage(clientLanguage);
                return locStrings.salaryRequestRequired})
        .max(10,() => {
                setLanguage(clientLanguage);
                return locStrings.salaryRequestMaxCharacters;
        })
    ,
    entranceDate: Yup.date()
        .when("EntranceDateIsValid", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.typeError(locStrings.entranceDateValidationError);
              },
        })
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.required(locStrings.entranceDateRequired);
              },
        }),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings, clientLanguage } = props;

    setLanguage(clientLanguage);

    function getClientLanguage(): string { 
        return getClientLanguageAsString(clientLanguage); 
    } 
    
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label className={"FormSalaryRequestText"}>{locStrings.salaryRequest}</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder={locStrings.salaryRequestPlaceholder}
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label className={"FormEntranceDateText"}>{locStrings.entranceDate}</Form.Label>
                <CustomFormControl
                    colors={colors}
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
      </>
    );
};